import { Checkbox, FormControlLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoTooltip from "../../../common/components/functional/InfoTooltip/InfoTooltip";
import { FlexVerticalAligned } from "../../../common/components/styled/styled";

export const IsBillableSelection = ({
  isBillable,
  onIsBillableChange,
  tooltipText,
  disabled = false,
}: {
  isBillable: boolean;
  onIsBillableChange: (isBillable: boolean) => void;
  tooltipText: string;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <FlexVerticalAligned>
      <FormControlLabel
        control={
          <Checkbox
            checked={!isBillable}
            disabled={disabled}
            onChange={(event) => {
              const checked = event.target.checked;
              onIsBillableChange(!checked);
            }}
          />
        }
        label={t("customers:orderTemplate:notBilled")}
        sx={{ marginRight: "8px" }}
      />
      <InfoTooltip title={tooltipText} />
    </FlexVerticalAligned>
  );
};
